import { z } from "zod";

export const FavoriteSchema = z.object({
  id: z.string(),
  name: z.string(),
  kcal: z.number().int(),
  proteinG: z.number().nullable(),
  fatG: z.number().nullable(),
  carbsG: z.number().nullable(),
  portionGrams: z.number().nullable(),
  useCount: z.number().int(),
  lastUsedAt: z.number().int().nullable(),
});
export type Favorite = z.infer<typeof FavoriteSchema>;

export const FavoriteCreateSchema = z.object({
  name: z.string().trim().min(1).max(200),
  kcal: z.number().int().min(0).max(10000),
  proteinG: z.number().min(0).max(500).nullable().optional(),
  fatG: z.number().min(0).max(500).nullable().optional(),
  carbsG: z.number().min(0).max(1000).nullable().optional(),
  portionGrams: z.number().min(0).max(5000).nullable().optional(),
});
export type FavoriteCreate = z.infer<typeof FavoriteCreateSchema>;
